import axios from 'axios';

const instance = axios.create({
  baseURL: `${document.location.origin}/api/v1/auth`,
});

export default instance;
